import { useEffect } from 'react';

import { FNode } from '@spazious/dollhouse-fsetup';
import { useEventCallback, useForceUpdate } from '@spazious/react-hooks';

import { useStore } from './useStore.js';

const uuidRegexp =
  /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/;

/**
 * Returns the graph with utility functions
 */
export const useGraph = () => {
  const forceUpdate = useForceUpdate();

  const graph = useStore(({ graph }) => graph);

  const find = useEventCallback((uuidOrSelector: string | null): FNode | null => {
    if (uuidOrSelector === null) {
      return graph as unknown as FNode;
    }
    if (uuidRegexp.test(uuidOrSelector)) {
      return graph.findByUUID(uuidOrSelector);
    }

    return graph.findBySelector(uuidOrSelector);
  });

  const exists = useEventCallback((uuid: string) => {
    return find(uuid) !== undefined;
  });

  useEffect(
    () =>
      graph.subscribe(() => {
        forceUpdate();
      }),
    [forceUpdate, graph]
  );

  return {
    graph,
    find,
    exists,
  };
};
